module.exports = __webpack_public_path__ + "img/user108.348f5151.jpg";